export default __webpack_public_path__ + "static/media/reports.16ff6ab9.svg";